import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from "react";
import { updateBillingDetails } from "./admin_helper";

function BillingSettings({ data, onStateChange }) {
    const [inputErrors, setInputErrors] = useState({});

    const validateInputs = () => {
        setInputErrors({});
        return true;
    }
    const handleBillingSave = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const invoice_key = Number(data.get("invoice_key"));
        const transaction_key = Number(data.get("transaction_key"));
        const cash_note_key = Number(data.get("cash_note_key"));
        const vch_num_key = Number(data.get("vch_num_key"));
        const pincode_fn = data.get("pincode_fn");
        const format = data.get("format");
        const inv_template = data.get("inv_template");

        var flag = true;
        if (invoice_key < 0) {
            setInputErrors({ inputErrors, "invoice_key": "Invalid invoice key." });
            flag = false;
        }
        if (transaction_key < 0) {
            setInputErrors({ inputErrors, "invoice_key": "Invalid transaction key." });
            flag = false;
        }
        if (cash_note_key < 0) {
            setInputErrors({ inputErrors, "invoice_key": "Invalid cash note key." });
            flag = false;
        }
        if (vch_num_key < 0) {
            setInputErrors({ inputErrors, "invoice_key": "Invalid voucher number key." });
            flag = false;
        }

        if (flag) {
            const _json = {
                "invoice": invoice_key, "transaction": transaction_key, "cash_note": cash_note_key,
                "pincode": pincode_fn, "format": format, "template": inv_template
            };
            onStateChange(true);
            updateBillingDetails(_json).then((res) => {
                onStateChange(false);
                console.log(res);
            }).catch((err) => {
                onStateChange(false);
                console.error(err);
            })
        }
    }

    return (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="password-change" id="password-change">
                <Typography color="primary" variant="body2" component="span">Billing Settings</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box component="form" onSubmit={handleBillingSave}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="invoice_key" error={inputErrors.invoice_key} helperText={inputErrors.invoice_key} defaultValue={data?.invoice_key ?? ""} fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 9999999 } }} placeholder="Invoice Key" label="Invoice Key" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="transaction_key" error={inputErrors.transaction_key} helperText={inputErrors.transaction_key} defaultValue={data?.transaction_key ?? ""} fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 9999999 } }} placeholder="Transaction Key" label="Transaction Key" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="cash_note_key" error={inputErrors.cash_note_key} helperText={inputErrors.cash_note_key} defaultValue={data?.cash_note_key ?? ""} fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 9999999 } }} placeholder="Cash Note Key" label="Cash Note Key" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="vch_num_key" error={inputErrors.vch_num_key} helperText={inputErrors.vch_num_key} defaultValue={data?.vch_num_key ?? ""} fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 9999999 } }} placeholder="Voucher Number Key" label="Voucher Number Key" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="pincode_fn" error={inputErrors.pincode_fn} helperText={inputErrors.pincode_fn} defaultValue={data?.pincode_fn ?? ""} fullWidth type="text" placeholder="Pincode Function" label="Location Function" disabled={true} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="format" error={inputErrors.format} helperText={inputErrors.format} defaultValue={data?.format ?? ""} fullWidth type="text" placeholder="Format" label="Format" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="inv_template" error={inputErrors.inv_template} helperText={inputErrors.inv_template} defaultValue={data?.inv_template ?? ""} fullWidth type="text" placeholder="Invoice Template" label="Invoice Template" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="info" style={{ textTransform: "none" }}>Save Billing Details</Button>
                        </Grid>
                    </Grid>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}

export default BillingSettings;
